import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';

const ONE_YEAR = 365;
const VIPPS_COOKIE_NAME = 'show_vipps_widget';

export const useVippsCookie = () => {
    const showModal = useMemo(() => {
        return Cookies.get(VIPPS_COOKIE_NAME) === undefined;
    }, []);

    const setCookie = useCallback(() => {
        Cookies.set(VIPPS_COOKIE_NAME, 'false', {
            expires: ONE_YEAR,
        });
    }, []);

    return { showModal, setCookie };
};
